export enum ListingCategoryTexts {
    Sales = 'SALES',
    Rental = 'RENTAL'
}